import { render, staticRenderFns } from "./SubSeries.vue?vue&type=template&id=3a55edae&scoped=true&"
import script from "./SubSeries.vue?vue&type=script&lang=js&"
export * from "./SubSeries.vue?vue&type=script&lang=js&"
import style0 from "./SubSeries.vue?vue&type=style&index=0&id=3a55edae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a55edae",
  null
  
)

export default component.exports